import React, { useState, useCallback } from 'react';
import styles from './EditContent.module.scss';
import Modal from '../../../../../components/modal/Modal';
import Button from '../../../../../components/button/Button';
import Select from '../../../../../components/select/Select';
import { SelectOption } from '../../../../../types';
type Props = {
  open: boolean;
  onClose: () => void;
  groupOptions: SelectOption[];
  onAddGroup: (groupName: string, groupId: string) => void;
};

function AddGroupModal({ open, onClose, groupOptions, onAddGroup }: Props) {
  const [group, setGroup] = useState<SelectOption | undefined>();
  const handleClose = () => {
    setGroup(undefined)
    onClose();
  };

  const handleSave = () => {
    if (group?.value) {
      onAddGroup(group.label, group.value)
    }
    setGroup(undefined)
  };

  const handleChangeGroups = useCallback((option: SelectOption) => setGroup(option), []);

  return (
    <Modal open={open} onClose={handleClose} className={styles.AddModalWrapper}>
      <div className={styles.title}>Select a Group:</div>
      <div className={styles.modalContentWrapper}>
        <Select options={groupOptions} className={styles.groupSelector} onChange={handleChangeGroups} value={group?.value}/>
        <div className={styles.contentDesc}>
          Do not assign a group to enable all Schools to see the content.
        </div>
        <div className={styles.contentDesc}>
          If you need to add a new group, create one from the Groups Menu.
        </div>
        <Button type={'submit'} onClick={handleSave} className={styles.addGroupModalBtn} label={group ? `Assign to ${group?.label}` : 'Please select a Group first'} disabled={!group} /> 
      </div>
    </Modal>
  );
}

export default AddGroupModal;
